import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  physician: (state: State) => state.physician,
  physicianUserInitData: (state: State) => state.physicianUserInitData,
  physicianUsers: (state: State) => state.physicians,
  physicianCount: (state: State) => state.physicianCount,
} as GetterTree<State, any>;
